import React, { useState } from 'react'
import styled from 'styled-components'
import cx from 'classnames'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import { Tooltip } from '@workboard/wobo-ui'

import Box from './box'
import Icon from './icon'

const HelpText = styled(({ className, children = '', alignment = 'top', hasArrow = true, isTitle = true }) => {
  const [isActive, setIsActive] = useState(false)

  const handlePointerEnter = () => {
    setIsActive(true)
  }

  const handlePointerLeave = () => {
    setIsActive(false)
  }

  const handleClick = () => {
    setIsActive(!isActive)
  }

  const classes = cx(className, 'm-help-text')

  return (
    <Box
      className={classes}
      onPointerEnter={handlePointerEnter}
      onPointerLeave={handlePointerLeave}
      onClick={handleClick}
    >
      <Tooltip
        arrow={hasArrow}
        isTitle={isTitle}
        content={children}
        placement={alignment}
      >
        <Icon component={HelpOutlineIcon} />
      </Tooltip>

    </Box>
  )
})``

export default HelpText
